import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { privacyPolicyData } from '@/constants/privacyPolicyData';

export const PrivacyPolicy = () => {
  const getIcon = (icon) => {
    // const icons = { Lock, FileText, UserCheck };
    // const Icon = icons[icon];
    // return Icon ? <Icon className="mb-[1rem] h-[3rem] w-[3rem] text-[#e24e1f]" /> : null;
  };

  return (
    <div className="mt-[12rem] flex w-full justify-center px-[2rem] font-inter lg:mt-[15rem]">
      <div className="w-full max-w-[100rem]">
        {/* Header */}
        <div className="mb-[4rem] text-center">
          <ShieldCheck className="mx-auto mb-[1rem] h-[5rem] w-[5rem] text-[#e24e1f]" />
          <h1 className="mb-[1rem] text-[3.6rem] font-[700] text-[#1C253C]">
            {privacyPolicyData.title}
          </h1>
          <p className="mx-auto max-w-[80rem] text-[1.6rem] text-[#555]">
            {privacyPolicyData.subtitle}
          </p>
        </div>

        {/* Sections */}
        {privacyPolicyData.sections.map((section) => (
          <div
            key={section.id}
            className="mb-[2rem] rounded-xl border border-[#eee] bg-white p-[3rem]"
          >
            {getIcon(section.icon)}
            <h2 className="mb-[1rem] text-[1.8rem] font-[700] text-[#1C253C] md:text-[2rem] lg:text-[2rem]">
              {section.title}
            </h2>

            {section.content.length > 1 ? (
              <ul className="list-disc space-y-[0.5rem] pl-[3rem] text-[1.6rem] text-[#555]">
                {section.content.map((line, index) => (
                  <li key={index}>{line}</li>
                ))}
              </ul>
            ) : (
              <p className="text-[1.6rem] text-[#555]">{section.content[0]}</p>
            )}
          </div>
        ))}

        {/* Footer */}
      </div>
    </div>
  );
};
